import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import { EmailSignUpSuccessModal } from "./EmailSignUpSuccessModal"
import {
    IEmailSignUpRequest
} from "../../models/EmailSignUp/IEmailSignUpRequest";
import {
    IEmailSignUpResponseHtml
} from "../../models/EmailSignUp/IEmailSignUpResponseHtml";
import { EventUtil } from "../../util/EventUtil";
import { PageContext } from "../../service/PageContext";
import { StringUtil } from "../../util/StringUtil";
import { UiUtil } from "../../util/UiUtil";

export class EmailSignUp extends Component {
    private readonly invalidClass = "is-invalid";
    private readonly _subscribe: HTMLButtonElement;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this._subscribe =
            DomUtil.query(element, "button[data-action='emailregister']");

        if (!this._subscribe) {
            return;
        }
        this._subscribe
            .addEventListener("click", ev => this.handleSubscribe(ev));

    }
    private async handleSubscribe(ev: Event): Promise<void> {
        const specialty: HTMLSelectElement =
            DomUtil.query(this._element, "select[data-email-list='specialty']");
        const emailInput: HTMLInputElement =
            DomUtil.query(this._element, "input[type='email']");

        const specialtyEmailList =
            specialty.options[specialty.selectedIndex].value;

        if (specialtyEmailList.length === 0 ||
            !StringUtil.isValidEmail(emailInput.value)) {
            if (specialtyEmailList.length === 0) {
                specialty.classList.add(this.invalidClass);
            } else {
                specialty.classList.remove(this.invalidClass);
            }
            if (!StringUtil.isValidEmail(emailInput.value)) {
                emailInput.classList.add(this.invalidClass);
            } else {
                emailInput.classList.remove(this.invalidClass);
            }

            return;
        }

        UiUtil.toggleButtonState(this._subscribe);
        const signUpRequest: IEmailSignUpRequest = {
            email: emailInput.value,
            eolist: this._subscribe.dataset.eolist || "",
            nwspec: specialtyEmailList,
            sendnotification: this._subscribe.dataset.sendnotification || "",
            source: this._subscribe.dataset.crmSource || ""
        };

        const context = this._pageContext;
        const service = context ? context.emailSignUpService : null;
        if (service) {
            const signUpResponse = await service.subscribe(signUpRequest);
            if (!signUpResponse) {
                return
            }
            const responseHtmlOptions =
                JSON.parse(this._subscribe.dataset.signupResponse
                    || "[]") as IEmailSignUpResponseHtml[];
            const responseHtml =
                responseHtmlOptions.find(
                    opt => opt.Name.indexOf(signUpResponse) > 0);

            if (responseHtml) {
                const detail = responseHtml.Text;
                this._element.dispatchEvent(
                    EventUtil.createCustomEvent(
                        EmailSignUpSuccessModal.SignedUpForEmails,
                        detail));
            }

            this._element.hidden = true;
        }
    }
}

ComponentFactory.registerComponent("EmailSignUp", EmailSignUp);
